/*
 * @Description: 密码强度
 * @Autor: lwq
 * @Date: 2020-07-28 10:49:16
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-28 11:01:20
 * @FilePath: \mrc-base-server-view\src\service\api\passwordIntensite.js
 */
// 岗位等级管理
import http from '../httpConfig'

const table = "mrbase_sys_password_security"

// 查看密码强度
export const showPasswordIntensity = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/passwordsecurity/find-pwdsecurity/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改密码强度
export const updatePasswordIntensity = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/passwordsecurity/update-pwdsecurity/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}